import store from '../../store'
import config from '../config/config'
import { NA } from '../constants/scores'
import { setWeakestLinkScores } from '../slices/weakestLinkScores'
import { setWeakestLinkVariables } from '../slices/weakestLinkVariables'

export default function calculateWeakestLinkScore(travellerType, scores) {
  if (scores) {
    const fileteredScores = Object.keys(scores).filter(
      (key) => scores[key] !== NA
    )
    const maxScore = fileteredScores.length
      ? Math.max(...fileteredScores.map((key) => scores[key]))
      : NA

    const maxScoreVariables = fileteredScores?.filter(
      (key) => Number(scores[key]) === maxScore
    )
    const configName = travellerType + 'Config'
    const maxScoreVariableNames = maxScoreVariables?.map(
      (variable) =>
        config[configName].find((config) => config.id === variable)?.name
    )
    store.dispatch(
      setWeakestLinkScores({ field: travellerType, value: maxScore })
    )
    store.dispatch(
      setWeakestLinkVariables({
        field: travellerType,
        value: maxScoreVariableNames
      })
    )
  }
}
